import { render, staticRenderFns } from "./UpsertSitelinksModal.vue?vue&type=template&id=4f70a1e2&scoped=true"
import script from "./UpsertSitelinksModal.vue?vue&type=script&lang=js"
export * from "./UpsertSitelinksModal.vue?vue&type=script&lang=js"
import style0 from "./UpsertSitelinksModal.vue?vue&type=style&index=0&id=4f70a1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f70a1e2",
  null
  
)

export default component.exports